export function createAuthorizationPolicyClient(transport) {
    return {
        /**
         * Evaluate a tenant-bound authorization decision
         *
         * Requires scope: authorization:decide
         */
        postAuthorizationDecisions(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/authorization/decisions",
                body,
                options,
            });
        },
        /**
         * List a tenant's authorization policies
         *
         * Requires scope: authorization:policy:read
         */
        getTenantsPolicies(tenantId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/policies`,
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Create a tenant policy
         *
         * Requires scope: authorization:policy:write
         */
        postTenantsPolicies(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/policies`,
                body,
                options,
            });
        },
        /**
         * Read one of a tenant's authorization policies
         *
         * Requires scope: authorization:policy:read
         */
        getTenantsPolicies2(tenantId, policyId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/policies/${encodeURIComponent(policyId)}`,
                options,
            });
        },
        /**
         * Replace a tenant policy using optimistic concurrency
         *
         * Requires scope: authorization:policy:write
         */
        putTenantsPolicies(tenantId, policyId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/policies/${encodeURIComponent(policyId)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=authorization-policy.js.map